import FieldsCollection from "../../fields3/collection/base/fields-collection"
import {FieldType} from "../../fields3/field-type"
import {EntityType} from "../../gd/const/item"
import FieldString from "../../fields3/generic/string/string"
import FieldText from "../../fields3/generic/text/text"
import FieldDropdown from "../../fields3/generic/dropdown/dropdown"

export default class ProjectViewFields extends FieldsCollection {

    constructor() {

        const fieldsConfig = [{
            fieldId         : 'name',
            label           : 'Name',
            type            : FieldType.STRING,
            description     : 'Enter a name for the view.',
        }, {
            fieldId         : 'contentUrl',
            label           : 'URL',
            type            : FieldType.STRING,
            description     : 'Add the full url.',
        }, {
            fieldId         : 'embedCode',
            label           : 'URL or Embed code',
            type            : FieldType.TEXT,
            description     : 'Enter the URL or HTML code to display content',
        }, {
            fieldId         : 'access',
            label           : 'Access',
            type            : FieldType.DROPDOWN,
            options         : [
                {value: 'private',  label: 'Private',   icon: 'i5-lock'},
                {value: 'public',   label: 'Public',    icon: 'i5-people'},
            ],
            showMenuMore    : false,
            noValueOption   : false,
            description     : 'Choose who can view this.',
        }]

        super(fieldsConfig, EntityType.DYNAMIC_MODEL)
    }

    get name()          : FieldString {return this.get('name') as FieldString}
    get contentUrl()    : FieldString {return this.get('contentUrl') as FieldString}
    get embedCode()     : FieldText {return this.get('embedCode') as FieldText}
    get access()        : FieldDropdown {return this.get('access') as FieldDropdown}
}
